import Api from 'shared/core/api'

export default {
  getThemes () {
    return Api().get('/themes');
  },
  getSeries () {
    return Api().get('/series');
  },
  getItems (queryParams) {
    return Api().get('/pois', { params: queryParams });
  },
  getItem (itemId, queryParams) {
    return Api().get(`/pois/${itemId}`, { params: queryParams });
  },
  deleteItem (itemId) {
    return Api().delete(`/pois/${itemId}`);
  },
  likeItem (itemId) {
    return Api().post(`/pois/${itemId}/likes`);
  },
  getComments (itemId) {
    return Api().get(`/pois/${itemId}/comments/`, { params: { expand: 'user', paginate: 100 } });
  },
  postComments (itemId, commentText) {
    return Api().post(`/pois/${itemId}/comments/`, { text: commentText });
  }
}
